


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import syncAlloyUtility from "@sparta.global-vtim.utilities/sync-alloy-utility/dist/es6.js"



window.spaWidgetParams = window.spaWidgetParams || {};
                       window.spaWidgetParams['gt-nav-unauth-secure-bofa-widget'] = window.spaWidgetParams['gt-nav-unauth-secure-bofa-widget'] || {};
                       window.spaWidgetParams['gt-nav-unauth-secure-bofa-widget']['1.0.0'] = window.spaWidgetParams['gt-nav-unauth-secure-bofa-widget']['1.0.0'] || {};
window.spaWidgetParams['gt-nav-unauth-secure-bofa-widget']['1.0.0'].dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.global.shared-components/spa-vue-link",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-link-es6" */ "@sparta.global.shared-components/spa-vue-link/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-badging",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-badging-es6" */ "@sparta.global.shared-components/spa-vue-badging/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-svg",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-svg-es6" */ "@sparta.global.shared-components/spa-vue-svg/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-button",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-button-es6" */ "@sparta.global.shared-components/spa-vue-button/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-nav-unauth-level1",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-nav-unauth-level1-es6" */ "@sparta.global-tenants.shared-components/gt-nav-unauth-level1/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-tab-nav",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-tab-nav-es6" */ "@sparta.global.shared-components/spa-vue-tab-nav/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-nav-unauth-level2",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-nav-unauth-level2-es6" */ "@sparta.global-tenants.shared-components/gt-nav-unauth-level2/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-picture",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-picture-es6" */ "@sparta.global.shared-components/spa-vue-picture/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-modal",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-modal-es6" */ "@sparta.global.shared-components/spa-vue-modal/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-ui-layers",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-ui-layers-es6" */ "@sparta.global.shared-components/spa-vue-ui-layers/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-card",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-card-es6" */ "@sparta.global.shared-components/spa-vue-card/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-nav-unauth-language-preference",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-nav-unauth-language-preference-es6" */ "@sparta.global-tenants.shared-components/gt-nav-unauth-language-preference/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-select",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-select-es6" */ "@sparta.global.shared-components/spa-vue-select/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-nav-unauth-hamburger",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-nav-unauth-hamburger-es6" */ "@sparta.global-tenants.shared-components/gt-nav-unauth-hamburger/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-drawer",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-drawer-es6" */ "@sparta.global.shared-components/spa-vue-drawer/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-squeezebox",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-squeezebox-es6" */ "@sparta.global.shared-components/spa-vue-squeezebox/dist/es6.js" )}
    },
    {
      name: "@sparta.global-tenants.shared-components/gt-nav-unauth-menutab",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-tenants-gt-nav-unauth-menutab-es6" */ "@sparta.global-tenants.shared-components/gt-nav-unauth-menutab/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.global-tenants.stores/gt-unauth-nav-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.global-tenants.stores/gt-unauth-nav-store-es6" */ "@sparta.global-tenants.stores/gt-unauth-nav-store/dist/es6.js" )}
    }
  ],
}



window.spaWidgetParams['gt-nav-unauth-secure-bofa-widget']['1.0.0'].getBootstrapUtilityInstance = function () { return spartaBootstrapUtility; };
